import React from 'react';
import { getTranslation } from '../../../../assets/creator/translations.js';
import './SimpleTypeSelector.css';

const SimpleTypeSelector = (props) => {
    // If props.typeSelector is '' then set path to binary type
    const typeSelector = props.typeSelector || 'binaryType';
    const selectorType = require('./../../../../assets/liquidSettingsTypes/' + typeSelector + '.json');

    const conditionalGetTranslation = (trueKey, falseKey) => {
        if (trueKey) {
            return getTranslation(trueKey);
        }
        return falseKey;
    }

    if (props.inputType === "checkbox") {
        return (
            <React.Fragment>
                {Object.keys(selectorType).map((key) => {
                    if (key !== '0') {
                        return null;
                    }
                    return (
                        <div key={key} className='simple-type-selector__right'>
                            <input type={props.inputType}
                                   id={`${selectorType[key].name}-${selectorType[key].value}`}
                                   value={selectorType[key].value} 
                                   defaultChecked={props.type === selectorType[key].value}
                                   name={selectorType[key].name}   
                                   onChange={props.typeHandler} />
                            <label htmlFor={`${selectorType[key].name}-${selectorType[key].value}`}>
                                {conditionalGetTranslation(props.translation, selectorType[key].value)}
                            </label> 
                        </div>
                    );
                })}
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <p className="options__info">{getTranslation(props.translation)}</p>
            {Object.keys(selectorType).map((key) => {
                return (
                    <div key={key} className='simple-type-selector__left'>
                        <input type="radio"
                               id={`${selectorType[key].name}-${selectorType[key].value}`}
                               value={selectorType[key].value} 
                               defaultChecked={props.type === selectorType[key].value}
                               name={selectorType[key].name}   
                               onChange={props.typeHandler} />
                        <label htmlFor={`${selectorType[key].name}-${selectorType[key].value}`}>
                            {conditionalGetTranslation(selectorType[key].translationKey, selectorType[key].value)}
                        </label>
                    </div>
                );
            })}
        </React.Fragment>
    );
};

export default SimpleTypeSelector;


